"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UNITS = exports.TOO_MANY_REQUESTS_STATUS_CODE = exports.TEXTAREA_MAX_LENGTH = exports.TEMPLATE_TYPES = exports.REWARD_STATUSES = exports.REWARD_CONTEXTS = exports.PERCENTAGE_TOGGLER_ICONS = exports.PACKAGE_STATUSES = exports.PACKAGE_AVAILABILITY_THRESHOLD = exports.MEDIA_TYPE = exports.MAX_DECIMALS = exports.INPUT_MAX_LENGTH = exports.GLOBAL_KEYWORD = exports.GENERAL_STATUSES_KEYS = exports.GENERAL_STATUSES = exports.FORBIDDEN_STATUS_CODE = exports.EXPIRY_TIMES = exports.EMAIL_REGEX = exports.DATE_TIME_FORMAT = exports.DATE_TIME_EMPTY_FORMAT = exports.DATE_TIME_DASH_FORMAT = exports.DATE_FORMAT = exports.CONFLICT_STATUS_CODE = exports.AUDIT_REQUEST_LIMIT = void 0;
var DATE_FORMAT = exports.DATE_FORMAT = 'dd/MM/yyyy';
var DATE_TIME_FORMAT = exports.DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';
var DATE_TIME_DASH_FORMAT = exports.DATE_TIME_DASH_FORMAT = 'dd-MM-yyyy HH:mm';
var DATE_TIME_EMPTY_FORMAT = exports.DATE_TIME_EMPTY_FORMAT = 'dd MMMM yyyy HH:mm';
var MAX_DECIMALS = exports.MAX_DECIMALS = 2;
var EMAIL_REGEX = exports.EMAIL_REGEX = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;
var UNITS = exports.UNITS = ['kb', 'mb'];
var GENERAL_STATUSES_KEYS = exports.GENERAL_STATUSES_KEYS = {
  STATUS_DRAFT: 'STATUS_DRAFT',
  STATUS_PUBLISHED: 'STATUS_PUBLISHED',
  STATUS_LIVE: 'STATUS_LIVE',
  STATUS_EXPIRED: 'STATUS_EXPIRED',
  STATUS_ERROR: 'STATUS_ERROR',
  STATUS_CALCULATING: 'STATUS_CALCULATING'
};
var GENERAL_STATUSES = exports.GENERAL_STATUSES = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  LIVE: 'live',
  EXPIRED: 'expired',
  ERROR: 'error',
  CALCULATING: 'calculating'
};
var REWARD_STATUSES = exports.REWARD_STATUSES = {
  calculating: 'calculating',
  live: 'live',
  expired: 'expired',
  published: 'published',
  draft: 'draft',
  error: 'error'
};
var PACKAGE_STATUSES = exports.PACKAGE_STATUSES = {
  draft: 'Draft',
  published: 'Published',
  live: 'Live',
  expired: 'Expired'
};
var MEDIA_TYPE = exports.MEDIA_TYPE = {
  IMAGE: 'Image',
  VIDEO: 'Video'
};
var TEMPLATE_TYPES = exports.TEMPLATE_TYPES = {
  simple: 'simple',
  share: 'share',
  pension: 'pension',
  flex: 'flex',
  percentage: 'percentage'
};
var REWARD_CONTEXTS = exports.REWARD_CONTEXTS = {
  reward: 'reward',
  share: 'share',
  flexPackage: 'flexPackage',
  fixedCosts: 'fixedCosts',
  ltiPlans: 'ltiPlans'
};
var PERCENTAGE_TOGGLER_ICONS = exports.PERCENTAGE_TOGGLER_ICONS = {
  NUMERIC: '123',
  PERCENTAGE: '%'
};
var GLOBAL_KEYWORD = exports.GLOBAL_KEYWORD = 'Global';
var INPUT_MAX_LENGTH = exports.INPUT_MAX_LENGTH = 1000;
var TEXTAREA_MAX_LENGTH = exports.TEXTAREA_MAX_LENGTH = 4000;
var EXPIRY_TIMES = exports.EXPIRY_TIMES = {
  HH: 1800,
  H: 3600
};
var CONFLICT_STATUS_CODE = exports.CONFLICT_STATUS_CODE = 412;
var FORBIDDEN_STATUS_CODE = exports.FORBIDDEN_STATUS_CODE = 403;
var TOO_MANY_REQUESTS_STATUS_CODE = exports.TOO_MANY_REQUESTS_STATUS_CODE = 429;
var PACKAGE_AVAILABILITY_THRESHOLD = exports.PACKAGE_AVAILABILITY_THRESHOLD = 28;

// limit for the audit reports, integer or false
var AUDIT_REQUEST_LIMIT = exports.AUDIT_REQUEST_LIMIT = 50;